import { render, staticRenderFns } from "./CreateCourseLessons.vue?vue&type=template&id=6061e3ec&scoped=true"
import script from "./CreateCourseLessons.vue?vue&type=script&lang=js"
export * from "./CreateCourseLessons.vue?vue&type=script&lang=js"
import style0 from "./CreateCourseLessons.vue?vue&type=style&index=0&id=6061e3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061e3ec",
  null
  
)

export default component.exports